import React from 'react';

import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import SiteModule from '@reverbdotcom/commons/src/components/site_module';
import { AddToCartButton } from '@reverbdotcom/commons/src/components/add_to_cart_button';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

import { Listing } from '../schemas/rql';

interface IExternalProps {
  shippingBoxListing: Listing,
  addToCartRedirectPath?: string;
}

type IProps = IExternalProps;

export default function Item2ShippingPromptBoxListing({ shippingBoxListing, addToCartRedirectPath }: IProps) {
  const boxListingPath = `/item/${shippingBoxListing.id}-${shippingBoxListing.slug}`;

  return (
    <SiteModule>
      <div className="g-container">
        <CoreLink
          target="_blank"
          className="g-col-4"
          to={boxListingPath}
          clickEvent={{
            eventName: MParticleEventName.ClickedReverbShippingBoxImageInsideShippingPrompt,
            listingId: shippingBoxListing.id,
          }}
        >
          <img
            alt={shippingBoxListing.title}
            className="width-100"
            src={shippingBoxListing.images[0].source}
          />
        </CoreLink>

        <div className="g-col-8">
          <CoreLink
            target="_blank"
            to={boxListingPath}
            clickEvent={{
              eventName: MParticleEventName.ClickedReverbShippingBoxTitleInsideShippingPrompt,
              listingId: shippingBoxListing.id,
            }}
          >
            {shippingBoxListing.title}
          </CoreLink>

          <h2 className="mt-1 mb-2 weight-bold">
            {shippingBoxListing.price.display}
          </h2>

          <AddToCartButton
            listing={shippingBoxListing}
            parentComponentName="Item2ShippingPromptBoxListing"
            redirectPath={addToCartRedirectPath}
            className="button button--gray"
          />
        </div>
      </div>
    </SiteModule>
  );
}
